import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

import { SupplierSubscriptionReleaseFlagsMessage } from './types/SupplierSubscriptionReleaseFlagsMessage';

const INACTIVE_RELEASE_FLAGS: SupplierSubscriptionReleaseFlagsMessage = {
    earlySubscriptionSignup: false,
    regularSubscriptionSignup: false,
    feeEnforcement: false,
};

export const useSupplierSubscriptionReleaseFlags = (enabled: boolean): SupplierSubscriptionReleaseFlagsMessage => {
    const { data } = useQuery({ ...queries.supplierSubscriptionReleaseFlags.current, enabled, throwOnError: false });
    return data ?? INACTIVE_RELEASE_FLAGS;
};
